import React from 'react';
import cn from 'classnames';
import { DebounceInput } from 'react-debounce-input';
import { ReactComponent as SearchIcon } from '../../assets/Search.svg';
import styles from './SearchInput.module.css';

type SearchInputProps = {
    onChange: (value: string) => void;
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    debounceTimout?: number;
    inputClassName?: string;
};

const SearchInput = ({
    debounceTimout = 750,
    placeholder = 'Search',
    value,
    className,
    disabled,
    onChange,
    inputClassName,
}: SearchInputProps) => (
    <div className={cn(styles.container, className)}>
        <SearchIcon className={styles.searchIcon} />
        <DebounceInput
            className={cn(styles.input, inputClassName)}
            type="text"
            disabled={disabled}
            debounceTimeout={debounceTimout}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />
    </div>
);

export default SearchInput;
